import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgHeading3 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M7 19.5v-6.25M7 7v6.25m0 0h10M17 7v12.5"
	})
});
export default SvgKgHeading3;
